import { cronosProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/cronos/default-constants';

export const CRONA_SWAP_CONTRACT_ADDRESS = '0xcd7d16fb918511bf7269ec4f48d61d79fb26f918';

export const CRONA_SWAP_PROVIDER_CONFIGURATION = cronosProviderConfiguration;
